import type { ListingType, PublishChoice } from '../domain/listings';

export interface ListingTypeOption {
  value: ListingType;
  label: string;
}

export const LISTING_TYPES: ListingTypeOption[] = [
  { value: 'sale', label: 'For Sale' },
  { value: 'job', label: 'Job Posting' },
  { value: 'event', label: 'Event' },
  { value: 'service', label: 'Service' },
  { value: 'housing', label: 'Housing' },
  { value: 'other', label: 'Other' },
];

export function listingTypeLabel(type: ListingType): string {
  return LISTING_TYPES.find((t) => t.value === type)?.label ?? 'Other';
}

/** "$40.00", or null when there's no price to show. */
export function formatPrice(price: string | null): string | null {
  if (price === null) return null;
  const amount = parseFloat(price);
  return isNaN(amount) ? null : `$${amount.toFixed(2)}`;
}

/** Router state for opening a listing's editor: the list to return to (021 FR-011c). */
export type EditOrigin = { from: string };

/** The list an editor was opened from, if the router state names one. */
export function originOf(state: unknown): string | null {
  const from = (state as Partial<EditOrigin> | null)?.from;
  return typeof from === 'string' ? from : null;
}

/** What a listing form's submit button says for each publish choice. */
export const PUBLISH_SUBMIT_LABEL: Record<PublishChoice, string> = {
  now: 'Publish',
  draft: 'Save draft',
  scheduled: 'Schedule',
};
